<template>
  <div>
    <!-- This module will render as a cms module and not with product card -->
    <!-- modal for customization -->
    <generic-modal
      v-if="showCustomizationModal"
      @close.stop="closeCustomizationModal($event, '')"
      :width="custModalDim.width"
      :modalClass="custModalDim.modalClass"
      :animationStyle="custModalDim.animationStyle"
      :maxHeight="custModalDim.height"
      :overflowNotNeeded="0"
      :padding="'0 0 0 0'"
      :genericModalSource="'customizationModal'"
      :headerPosition="'sticky'"
      :headerZIndex="'9999'"
      :headerTop="'0px'"
      :headerBackground="'white'"
    >
      <template v-slot:header>
        <div :class="[clientPlatform == 'Web' ? '' : 'customization-header']">
          <div class="slide-handle"></div>
        </div>
      </template>
      <template v-slot:body>
        <div class="customization-pop-content">
          <!-- product customization card -->
          <product-customization
            @close.stop="closeCustomizationModal($event, '')"
          ></product-customization>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!-- Modal for repeat/add new customization -->
    <generic-modal
      v-if="showRepeatCustModal"
      @close.stop="closeRepeatCustModal($event, '')"
      :width="cartEditModalDim.width"
      :modalClass="cartEditModalDim.modalClass"
      :animationStyle="cartEditModalDim.animationStyle"
      :maxHeight="custModalDim.height"
      :overflowNotNeeded="0"
      :genericModalSource="'repeatCustModal'"
    >
      <template v-slot:header>
        <div class="slide-handle"></div>
        <div class="fs-16 bold mt15 mb16 color-slaty">
          Your Last Customisation
        </div>
      </template>
      <template v-slot:body>
        <div class="customization-pop-content">
          <div class="cards-holder">
            <repeat-edit-product-cart
              :data-item="lastAddedItem"
              @close.stop="closeRepeatCustModal($event, '')"
            >
            </repeat-edit-product-cart>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <!-- bottom fixed -->
        <div class="customise-repeat-bottom d-flex justify-content-between">
          <div class="line-btn sm repeat-btn" @click="handleAddNewCTA">
            Customise Again
          </div>
          <div
            class="line-btn sm repeat-btn secondary"
            @click="handleRepeatCTA"
          >
            Repeat Last
          </div>
        </div>
      </template>
    </generic-modal>

    <!-- modal for Edit Cart (triggered on clicking minus on cta) -->
    <generic-modal
      v-if="showEditMiniCartModal"
      @close.stop="closeEditCartModal($event, '')"
      :width="cartEditModalDim.width"
      :modalClass="cartEditModalDim.modalClass"
      :animationStyle="cartEditModalDim.animationStyle"
      :maxHeight="cartEditModalDim.height"
      :overflowNotNeeded="0"
      :padding="'0'"
      :paddingBottom="'0'"
      :genericModalSource="'editCartModal'"
    >
      <template v-slot:header>
        <div class="slide-handle"></div>
        <div class="fs-16 bold mt15 mb16 color-slaty plr16">
          Your Customised Combos
        </div>
      </template>
      <template v-slot:body>
        <div class="customization-pop-content plr16">
          <div
            v-for="(value, key, index) in allCustItemsInMiniCart"
            :key="index"
            class="cards-holder"
          >
            <repeat-edit-product-cart
              :data-item="value"
              :data-key="key"
              @removeFromCartForCombo="removeFromCartForCombo"
              @addToCartForCombo="addToCartForCombo"
              @close.stop="closeEditCartModal($event, '')"
              class="mb16"
            >
            </repeat-edit-product-cart>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <!-- bottom fixed -->
        <div class="customised-details">
          <div
            class="btn bold custm-cta secondary"
            @click="closeEditCartModal($event, '')"
          >
            Update Cart
          </div>
        </div>
      </template>
    </generic-modal>
  </div>
</template>

<script>
import GenericModal from "./GenericModal.vue";
import ProductCustomization from "./ProductCustomization.vue";
import HongsProductCard from "./HongsProductCard.vue";
import { keyMapsMutation, keyMapsGetter } from "../helpers/storeKeys";
import RepeatEditProductCart from "./RepeatEditProductCart.vue";
import Utility from "../helpers/utility.js";
import {
  EVENT_CLICK_OPTIN_POPUP_ADD_NEW,
  EVENT_CLICK_OPTIN_POPUP_REPEAT_LAST,
  EVENT_CLICK_MINICART_ADD,
  EVENT_CLICK_MINICART_REMOVE,
  EVENT_CLICK_MINICART_UPDATE,
} from "../helpers/analyticsEvents";
import { clientPlatform } from "../config/apiEndpoints";

export default {
  name: "CustomizationInit",
  components: {
    GenericModal,
    ProductCustomization,
    HongsProductCard,
    RepeatEditProductCart,
  },
  // props: ['dataResults'],
  data() {
    return {
      custModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px) !important",
        animationStyle: "slide-up-stick-bottom",
        modalClass:
          "tnc-modal modal-customization full-screen-popup lg-screen-centered",
      },
      cartEditModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px) !important",
        animationStyle: "slide-up-stick-bottom",
        modalClass:
          "tnc-modal modal-edit-cart full-screen-popup lg-screen-centered",
      },
      productCardProps: {
        cardRounded: true,
        smallCards: true,
        hideImage: true,
      },
      lastAddedItem: {},
      editItemsListMiniCartCust: {},
      itemsQuantityMiniCartCust: {},
      allCustItemsInMiniCart: {},
      clientPlatform,
    };
  },
  mounted() {
    //
  },
  methods: {
    closeCustomizationModal(e, source) {
      e.stopPropagation();
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_CUSTOMISABLE_FOR, "");
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL,
        false
      );
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    closeEditCartModal(e, source) {
      EVENT_CLICK_MINICART_UPDATE();
      e.stopPropagation();
      (this.editItemsListMiniCartCust = {}),
        (this.itemsQuantityMiniCartCust = {}),
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_EDIT_MINI_CART_MODAL,
          false
        );
      this.allCustItemsInMiniCart = {};
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    closeRepeatCustModal(e, source) {
      e.stopPropagation();
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_REPEAT_CUST_MODAL, false);
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    updateDisableItemToastMsg() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, false);
    },
    handleRepeatCTA() {
      EVENT_CLICK_OPTIN_POPUP_REPEAT_LAST();
      this.$store.commit(keyMapsMutation.ADD_TO_CART, this.lastAddedItem);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item added to the cart."
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_REPEAT_CUST_MODAL, false);
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    handleAddNewCTA() {
      EVENT_CLICK_OPTIN_POPUP_ADD_NEW();
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_CUSTOMIZATION_MODAL, true);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_REPEAT_CUST_MODAL, false);
      document.body.classList.remove("body-stop-scroll-mobile");
    },
    computeProductItemsListCombo() {
      this.editItemsListMiniCartCust = {};
      this.itemsQuantityMiniCartCust = {};
      let showCustomisableFor =
        this.$store.state.ProductItems.showCustomisableFor;
      if (
        showCustomisableFor &&
        this.$store.state.Cart.items[showCustomisableFor] &&
        this.$store.state.Cart.items[showCustomisableFor].length > 0
      ) {
        let cartItemsArray = Object.values(
          JSON.parse(JSON.stringify(this.$store.state.Cart.items))
        );
        let i = 0,
          j = 0;
        cartItemsArray.map((x) => {
          if (
            x[0]?.parentSkuId == showCustomisableFor ||
            x[0]?.skuId == showCustomisableFor
          ) {
            j = i;
            return j;
          } else {
            i++;
          }
        });
        cartItemsArray[j]?.map((item) => {
          let key = "";
          if (item?.selectedVariant) {
            let productItem = item?.selectedVariant?.skuId;
            key = item.parentSkuId + "*" + productItem;
          } else {
            let productItemsIdArray = item?.selectedComboVariant
              ?.map((x) => x?.items?.map((i) => i?.parentSkuId))
              .flat();
            key = item.skuId + "*" + productItemsIdArray.join("*");
          }
          this.editItemsListMiniCartCust[key] = item;
          if (this.itemsQuantityMiniCartCust[key]) {
            this.itemsQuantityMiniCartCust[key] += 1;
          } else {
            this.itemsQuantityMiniCartCust[key] = 1;
          }
        });
      }
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEMS_LIST_MINI_CART_CUST,
        this.editItemsListMiniCartCust
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEMS_QUANTITY_MINI_CART_CUST,
        this.itemsQuantityMiniCartCust
      );
    },
    removeFromCartForCombo(item) {
      this.$store.commit(keyMapsMutation.REMOVE_FROM_CART, item);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item removed from the cart."
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
      if (
        Object.keys(this.$store.state.Cart.items).length &&
        ((item.parentSkuId &&
          !this.$store.state.Cart.items[item.parentSkuId]) ||
          (item.skuId && !this.$store.state.Cart.items[item.skuId]))
      ) {
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_EDIT_MINI_CART_MODAL,
          false
        );
        document.body.classList.remove("body-stop-scroll-mobile");
      }
      this.computeProductItemsListCombo();
      EVENT_CLICK_MINICART_REMOVE({ productName: item?.displayName });
    },
    addToCartForCombo(item) {
      this.$store.commit(keyMapsMutation.ADD_TO_CART, item);
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_ITEM_TOAST_MSG, true);
      this.$store.commit(
        keyMapsMutation.UPDATE_ITEM_TOAST_MSG,
        "1 Item added to the cart."
      );
      setTimeout(this.updateDisableItemToastMsg, 1000);
      this.computeProductItemsListCombo();
      EVENT_CLICK_MINICART_ADD({ productName: item?.displayName });
    },
  },
  computed: {
    product() {
      let showCustomisableFor =
        this.$store.state.ProductItems.showCustomisableFor;
      return this.$store.state.ProductItems.products[
        Object.keys(
          this.$store.state.ProductItems.productCategoryMap[showCustomisableFor]
        )[0]
      ][showCustomisableFor];
    },
    showCustomisableFor() {
      return this.$store.state.ProductItems.showCustomisableFor;
    },
    showCustomizationModal() {
      if (
        this.$store.state.ProductItems.showCustomisableFor &&
        this.$store.state.ProductItems.showCustomizationModal
      ) {
        setTimeout(() => {
          typeof searchQueryInputModal === "undefined"
            ? ""
            : searchQueryInputModal.blur();
        }, 0);
      }
      return (
        this.$store.state.ProductItems.showCustomisableFor &&
        this.$store.state.ProductItems.showCustomizationModal
      );
    },
    showEditMiniCartModal() {
      if (this.$store.state.ProductItems.showEditMiniCartModal) {
        this.computeProductItemsListCombo();
      }
      if (
        this.$store.state.ProductItems.showEditMiniCartModal &&
        Object.keys(this.itemsListMiniCartCust).length > 0
      ) {
        setTimeout(() => {
          typeof searchQueryInputModal === "undefined"
            ? ""
            : searchQueryInputModal.blur();
        }, 0);
      }
      return (
        this.$store.state.ProductItems.showEditMiniCartModal &&
        Object.keys(this.itemsListMiniCartCust).length > 0
      );
    },
    showRepeatCustModal() {
      let showCustomisableFor =
        this.$store.state.ProductItems.showCustomisableFor;
      if (
        showCustomisableFor &&
        Object.keys(this.$store.state.Cart.items).length &&
        this.$store.state.Cart.items[showCustomisableFor]?.length
      ) {
        this.lastAddedItem = this.getLastAddedItemFromCart(showCustomisableFor);
      }
      if (this.$store.state.ProductItems.showRepeatCustModal) {
        setTimeout(() => {
          typeof searchQueryInputModal === "undefined"
            ? ""
            : searchQueryInputModal.blur();
        }, 0);
      }
      return this.$store.state.ProductItems.showRepeatCustModal;
    },
    getLastAddedItemFromCart() {
      return (parentSkuId) => {
        return this.$store.getters[keyMapsGetter.GET_LAST_ADDED_ITEM_FROM_CART](
          parentSkuId
        );
      };
    },
    itemsListMiniCartCust() {
      let itemsList = this.$store.state.ProductItems.itemsListMiniCartCust;
      if (Object.keys(this.allCustItemsInMiniCart).length == 0) {
        this.allCustItemsInMiniCart = itemsList;
      }
      return itemsList;
    },
  },
};
</script>
